// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/statsIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Statistics" aria-label="Statistics" />;
}
